export default __webpack_public_path__ + "static/media/iamelsy.885af2f6.png";